//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios'
import qs from 'qs'
import InputText from '~/components/layout/InputText'
export default {
	components: {
		InputText
	},
	data() {
		return {
			placeholder_mail: this.$t('placeholder_mail'),
			placeholder_title: this.$t('placeholder_title'),
			placeholder_message: this.$t('placeholder_message'), 
			answer:'',
			title_mail: '',
			message: '',
			your_mail: '',
			show_answer_ok: false,
			show_answer_ko: false,
			envBaseUrlAdmin: process.env.envBaseUrlAdmin
		};
	},
	methods: {
		submit_form(event){
			console.log('clicked form')
			event.preventDefault()
			console.log(!this.your_mail)
			console.log(this.your_mail)
			if(!this.your_mail){
				this.placeholder_mail = this.$t('confirm_placeholder_mail')
				return false
			}
			if(!this.title_mail){
				this.placeholder_title = this.$t('confirm_placeholder_title')
				return false
			}
			console.log(this.message.length)
			if(!this.message.length){
				this.placeholder_message = this.$t('confirm_placeholder_message')
				return false
			}
			axios({
				method: 'post',
				url:  'https://myadmin.romza.eu/wp-admin/admin-ajax.php?action=mail_before_submit',
				data: qs.stringify({ 'message': this.message,  'title_mail': this.title_mail,  'your_mail': this.your_mail }),
				config: {
					headers: {
						'Access-Control-Allow-Origin': '*',
					}
				},
			})
			.then((response) => {
				this.answer =this.$t('message_send')
				this.show_answer_ok = true
				this.show_answer_ko = false
				console.log(response);
			}, (error) => {
				this.answer = this.$t('message_error')
				this.show_answer_ok = false
				this.show_answer_ko = true
				console.log(error);
			});
		},
	},
}
